import StyleCollection from './StyleCollection';

export {
    StyleCollection
};



// WEBPACK FOOTER //
// ./plugins/HistomicsTK/web_client/collections/index.js